import { LiquidityStreamRequest } from 'widgets/liquiditySummary/api/LiquiditySummaryStreamRequest';
import {
    StreamRequestInfo,
    WidgetCustomStreamManager,
    WidgetStreamByRequestUidConfig,
} from 'widgets/streaming/widgetStreamManager/WidgetCustomStreamManager';
import {
    WidgetStreamByRequestUidStreamManager,
    WidgetStreamByRequestUidStreamManagerOptions,
} from 'widgets/streaming/widgetStreamManager/WidgetStreamByRequestUidStreamManager';
import State from 'store/State';
import { WidgetId } from 'widgets/WidgetId';
import {
    getLiquidityStreamRequestInfosForSymbols,
    getLiquidityStreamRequestInfo,
} from './LiquiditySummaryStreamRequest';
import { buildLiquiditySummaryStreamHandlers } from 'widgets/liquiditySummary/store/data/handler';
import LiquiditySummaryDataMessage from 'widgets/liquiditySummary/api/LiquiditySummaryDataMessage';
import { DataServices } from 'store/Services';
import { LiquiditySummaryConfiguration } from 'widgets/liquiditySummary/store/configuration/LiquiditySummaryConfiguration';

export const liquidityStreamConfig: WidgetStreamByRequestUidConfig<LiquidityStreamRequest> =
    {
        channelDestination: 'startLiquidityStream',
        managerFactory(
            options: WidgetStreamByRequestUidStreamManagerOptions<LiquiditySummaryDataMessage>
        ): WidgetCustomStreamManager {
            return new WidgetStreamByRequestUidStreamManager({
                ...options,
                buildHandlers: buildLiquiditySummaryStreamHandlers,
            });
        },
        getWidgetStreamRequestInfo(
            state: State,
            services: DataServices,
            id: WidgetId
        ): Promise<StreamRequestInfo<LiquidityStreamRequest> | undefined> {
            return getLiquidityStreamRequestInfo(state, services, id);
        },
        getStreamRequestInfosForSymbols(
            state: State,
            services: DataServices,
            symbols: string[],
            _config: LiquiditySummaryConfiguration,
            quantities: number[]
        ): Promise<StreamRequestInfo<LiquidityStreamRequest>[]> {
            return getLiquidityStreamRequestInfosForSymbols(
                state,
                services,
                symbols,
                {},
                quantities
            );
        },
    };
